export default {
  setUserPermissions(state, userPermissions) {
    localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
    state.permissions = userPermissions;
  },
}
